import { Component } from '@angular/core';

@Component({
  selector: 'tr-main',
  templateUrl: './main.component.html',
  //styleUrls: ['./main.component.scss']
})
export class MainComponent {

}



// WEBPACK FOOTER //
// ./src/app/shared/components/main/main.component.ts